import dataService from 'services/dataService';
import { showResult } from 'infrastructure/hooks/utils';

interface DataProps {
  url: string;
}

export interface ISelect {
  guid: string;
  createdAt: string;
}

export const selectKeyNotesHistory = async ({ url }: DataProps) => {
  const { error, data } = await dataService.getList<ISelect[]>(url);

  if (error) {
    showResult(error);
  }

  return data;
};
